import type { Module } from '@pc/core';
import { probeSchemaIsExposed } from '@pc/db';
import { lazyWithReload } from '@pc/ui';

const ShippingHomePage = lazyWithReload(() => import('./pages/ShippingHomePage'));
const ShippingLabelsPage = lazyWithReload(() => import('./pages/ShippingLabelsPage'));

// Label purchase on ship-type orders lives on each shipment row inside
// @pc/modules-fulfillment's FulfillmentShipmentPanel (not a second
// order-level panel here).

export const shippingModule: Module = {
  id: 'shipping',
  name: 'Shipping',
  description:
    'Connect carrier accounts (Shippo, EasyPost, UPS, PirateShip), quote rates, and buy labels directly from orders. Add-on on Beginner/Pro; included on Expert.',
  basePath: '/shipping',
  routes: [
    { path: '/', element: <ShippingHomePage /> },
    { path: '/labels', element: <ShippingLabelsPage /> },
  ],
  navItems: [{ label: 'Shipping', to: '/shipping', order: 35 }],
  dashboardWidgets: [],
  events: {
    publishes: [],
    subscribesTo: {},
  },
  healthProbe: () => probeSchemaIsExposed('shipping', 'v_label_summary'),
};
